import { render, staticRenderFns } from "./TranslationCard.vue?vue&type=template&id=6a24ad64&"
import script from "./TranslationCard.vue?vue&type=script&lang=js&"
export * from "./TranslationCard.vue?vue&type=script&lang=js&"
import style0 from "./TranslationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports